export interface FurnitureDef {
  id: string;
  label: string;
  emoji: string;
  price: number;
  footprint: { w: number; d: number };
}

export const FURNITURE_CATALOG: FurnitureDef[] = [
  { id: 'bed', label: 'Cozy Bed', emoji: '🛏️', price: 0, footprint: { w: 1.5, d: 2.3 } },
  { id: 'table', label: 'Round Table', emoji: '🪵', price: 0, footprint: { w: 1.5, d: 1.5 } },
  { id: 'chair', label: 'Chair', emoji: '🪑', price: 0, footprint: { w: 0.6, d: 0.6 } },
  { id: 'rug', label: 'Pink Rug', emoji: '🟣', price: 0, footprint: { w: 2.3, d: 2.3 } },

  { id: 'lamp', label: 'Petal Lamp', emoji: '💡', price: 20, footprint: { w: 0.5, d: 0.5 } },
  { id: 'bookshelf', label: 'Bookshelf', emoji: '📚', price: 40, footprint: { w: 1.3, d: 0.5 } },
  { id: 'pottedPlant', label: 'Potted Plant', emoji: '🪴', price: 15, footprint: { w: 0.7, d: 0.7 } },
  { id: 'painting', label: 'Painting', emoji: '🖼️', price: 25, footprint: { w: 1.0, d: 0.3 } },
  { id: 'cushion', label: 'Cushion', emoji: '🧸', price: 10, footprint: { w: 0.8, d: 0.8 } },
  { id: 'mushroomStool', label: 'Mushroom Stool', emoji: '🍄', price: 20, footprint: { w: 0.9, d: 0.9 } },
  { id: 'crystalOrb', label: 'Crystal Orb', emoji: '🔮', price: 60, footprint: { w: 0.5, d: 0.5 } },
  { id: 'fountain', label: 'Mini Fountain', emoji: '⛲', price: 80, footprint: { w: 1.8, d: 1.8 } },
];

export const STARTER_FURNITURE = ['bed', 'table', 'chair', 'rug'];

export function findFurniture(id: string): FurnitureDef | undefined {
  return FURNITURE_CATALOG.find((f) => f.id === id);
}
